// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deactivate_containers_pgm {
  overflow: hidden;
  height: 100vh;
}
.deactivate_containers_pgm .pgmcontainers_details {
  overflow: hidden;
}
.deactivate_containers_pgm .pgmdetails_container {
  width: 100%;
  display: flex;
  overflow: hidden;
  height: 100vh;
}
.deactivate_containers_pgm .page_minimize-pgm-details {
  float: right;
  margin: 2.4rem 1rem;
}
.deactivate_containers_pgm .vehicle-sale-parts {
  display: flex;
  justify-content: space-between;
  width: 97%;
  margin: 0rem 1rem;
}
.deactivate_containers_pgm .pgmdetails {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
}
.deactivate_containers_pgm .pgm_details_container_s {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 85vh;
}
.deactivate_containers_pgm .footer-div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.deactivate_containers_pgm .header_border {
  background: #C0C8DA;
  height: 2.4rem;
  border: 1px solid #c0c8da;
}
.deactivate_containers_pgm .header_border > img {
  margin: 0.9rem 1rem;
}
.deactivate_containers_pgm .pgmdetails_textbuttons {
  display: flex;
  justify-content: space-between;
  margin: 1rem;
}
.deactivate_containers_pgm .details_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  color: #10132e;
}
.deactivate_containers_pgm .pgmdetails_firstpara_text_Please {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  color: #ba1a1a;
  margin: 1rem;
}
.deactivate_containers_pgm .checkbox {
  width: 20px;
  height: 20px;
}
.deactivate_containers_pgm .details_close {
  width: 4.4rem;
  height: 1.8rem;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.deactivate_containers_pgm .details_approved {
  width: 5.7rem;
  height: 1.8rem;
  background: #00b55e;
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.deactivate_containers_pgm .details_approved:disabled {
  width: 5.7rem;
  height: 1.8rem;
  background: #48f2a0;
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.deactivate_containers_pgm .details_need {
  width: 11.1rem;
  height: 1.8rem;
  background: #10132E;
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.deactivate_containers_pgm .pgmactive-deactivate {
  background: #00B55E;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0rem 0.4rem;
  border-radius: 5px;
  padding: 0.2rem 0.8rem;
}
.deactivate_containers_pgm .change-role-deactivate {
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding: 0rem 1rem;
  margin: 0.8rem 1rem;
  border-radius: 5px;
}
.deactivate_containers_pgm .details_need:disabled {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 11.1rem;
  height: 1.8rem;
  background: #10132E;
  border-radius: 5px;
  border: none;
  opacity: 0.2;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.deactivate_containers_pgm .pgmdetails_allbutoons {
  display: flex;
  gap: 1rem;
}
.deactivate_containers_pgm .pgmdetails_firstpara-deactivate {
  margin: 1rem;
  display: flex;
  justify-content: space-between;
  background: #f2f4ff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
}
.deactivate_containers_pgm .pgmdetails_firstpara {
  margin: 1rem;
  background: #f2f4ff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
}
.deactivate_containers_pgm .pgmdetails_firstpara_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1.12rem;
  align-items: center;
  text-align: center;
  display: flex;
  gap: 1rem;
  color: #0c3688;
  padding: 1rem;
}
.deactivate_containers_pgm [role=button] {
  cursor: pointer;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0c3688;
  margin: 1rem 0.5rem;
}
.deactivate_containers_pgm .checkbox_div {
  display: flex;
  gap: 1rem;
}
.deactivate_containers_pgm .pgm-details-pgmlist {
  word-spacing: 0.4rem;
}
.deactivate_containers_pgm .checkbox_divs {
  display: flex;
  margin: 1rem;
  gap: 1rem;
}
.deactivate_containers_pgm .checkbox_divs > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #0c3688;
}
.deactivate_containers_pgm .googlemaptext {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  cursor: pointer;
  display: flex;
  gap: 0.4rem;
}
.deactivate_containers_pgm .googlemaptext-bold {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0C3688;
  cursor: pointer;
  display: flex;
  gap: 0.4rem;
}
.deactivate_containers_pgm .profile_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #0c3688;
  margin: 0rem 0.9rem;
}
.deactivate_containers_pgm .profile_pgm_details {
  background: #f4f6fd;
  border-radius: 6px;
  margin: 1rem;
  display: flex;
  padding: 1rem 0rem;
}
.deactivate_containers_pgm .profilepgm_profileicons {
  width: 20%;
  margin: 1rem;
}
.deactivate_containers_pgm .profilepgm_profileicons .profile_img {
  height: 8rem;
  width: 8rem;
}
.deactivate_containers_pgm .store-img {
  height: 8.812rem;
  width: 9.31rem;
  border: 1px;
  border-radius: 8px;
}
.deactivate_containers_pgm .veryfication_images {
  border-radius: 5px;
  border: 1px;
  width: 13.68rem;
  height: 8.81rem;
}
.deactivate_containers_pgm .profile_iconstext {
  width: 80%;
  border-left: 2px solid #ffffff;
}
.deactivate_containers_pgm .Profile_icon_border {
  border-bottom: 2px solid #ffffff;
}
.deactivate_containers_pgm .Profile_icon_text_spare {
  display: flex;
  justify-content: space-between;
  width: 60.5%;
  margin: 1rem;
}
.deactivate_containers_pgm .Profile_icon_text_span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  color: #0c3688;
  gap: 1rem;
}
.deactivate_containers_pgm .Profile_icon_text_para {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #32363f;
  gap: 1rem;
  display: flex;
}
.deactivate_containers_pgm .Profilepgmdetails_email {
  margin: 1rem;
  display: flex;
  gap: 1rem;
}
.deactivate_containers_pgm .pgm_details_parathird {
  background: #f2f4ff;
  border-radius: 6px;
  margin: 1rem;
  display: flex;
  justify-content: space-between;
}
.deactivate_containers_pgm .pgm_details_parathird > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  color: #0c3688;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.deactivate_containers_pgm .pgm_details_parathird > img {
  width: 31px;
  height: 31px;
  padding: 1rem;
}
.deactivate_containers_pgm .pgm_details_parafourth {
  background: #f2f4ff;
  border-radius: 6px;
  margin: 1rem;
}
.deactivate_containers_pgm .pgm_details_parafourth_textspare {
  display: flex;
  justify-content: space-between;
  margin: 1rem;
}
.deactivate_containers_pgm .pgm_details_parafourth_textspare > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0c3688;
  margin: 0.7rem 0rem;
  display: flex;
  gap: 1rem;
  padding: 0.4rem;
}
.deactivate_containers_pgm .pgm_details_parafourth_textsparespans {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0c3688;
  margin: 1rem 0rem;
  display: flex;
  gap: 1rem;
  padding: 0.4rem;
}
.deactivate_containers_pgm .pgm_details_parafourth_textspare > img {
  margin: 1rem 0rem;
}
.deactivate_containers_pgm .pgm_details_parafive {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #0c3688;
  margin: 1rem;
}
.deactivate_containers_pgm .pgmdetails_parasix {
  height: 49px;
  background: #f2f4ff;
  border-radius: 6px;
  margin: 1rem 0rem;
  width: 99%;
}
.deactivate_containers_pgm .pgmdetails_sixspan {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #32363f;
  padding: 1rem;
  display: flex;
}
.deactivate_containers_pgm .veryfication_border {
  background: #ffffff;
  border: 1px solid #a3aec4;
  border-radius: 5px;
}
.deactivate_containers_pgm .veryfication_img {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem;
}
.deactivate_containers_pgm .pgm_details_sevenpara {
  display: flex;
}
.deactivate_containers_pgm .pgm_details_sevenparas {
  display: flex;
  margin: 1rem 0rem;
}
.deactivate_containers_pgm .pgm_details_eight_paras {
  display: flex;
  gap: 1.5rem;
  margin: 2rem 0rem;
}
.deactivate_containers_pgm .veryfication_img > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #0c3688;
  display: flex;
  gap: 1rem;
}
.deactivate_containers_pgm .veryfication_img > img {
  margin: -0.6rem 0rem;
}
.deactivate_containers_pgm .commercial {
  margin-top: 8rem 0rem;
}
.deactivate_containers_pgm .Profile_icon_text_organization {
  display: flex;
  justify-content: space-between;
  width: 72%;
  margin: 1rem;
}
.deactivate_containers_pgm .Profile_icon_text_organization_records {
  display: flex;
  justify-content: space-between;
  width: 72%;
  margin: 1rem;
}
.deactivate_containers_pgm .Profile_icon_text_records_businees {
  display: flex;
  justify-content: space-between;
  width: 80.5%;
  margin: 1rem;
}
.deactivate_containers_pgm .Profile_icon_text_postal {
  display: flex;
  justify-content: space-between;
  width: 65.5%;
  margin: 1rem;
}
.deactivate_containers_pgm .Profile_icon_text_province {
  display: flex;
  justify-content: space-between;
  width: 70.5%;
  margin: 1rem;
}
.deactivate_containers_pgm .Profile_icon_text {
  display: flex;
  width: 96%;
  margin: 1rem 1.4rem;
  padding: 0rem 0rem;
}
.deactivate_containers_pgm .Profile_icon_text_profiledetails {
  display: flex;
  width: 70%;
  justify-content: space-between;
  margin: 1rem;
}
.deactivate_containers_pgm .profile_commercial {
  width: 46%;
}
.deactivate_containers_pgm .profile_commercials {
  width: 46%;
}
.deactivate_containers_pgm .Pgm_Profile_details {
  display: flex;
  width: 100%;
}
.deactivate_containers_pgm .Pgm_Profile_details > img {
  width: 85%;
}
.deactivate_containers_pgm .Pgm_Profile_questionaire {
  display: flex;
  width: 100%;
}
.deactivate_containers_pgm .Pgm_Profile_questionaire > img {
  width: 78%;
}
.deactivate_containers_pgm .Pgm_Profile_businees {
  display: flex;
  width: 100%;
}
.deactivate_containers_pgm .partnerspara_tens_span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #1445a4;
  padding: 1rem 0rem;
  margin: 1rem;
}
.deactivate_containers_pgm .page_minimizes {
  float: right;
  right: 2.4rem;
  margin: 0rem -0.1rem;
}
.deactivate_containers_pgm .page_minimize2s {
  float: right;
  right: 2.4rem;
  margin: 1.6rem 0.8rem;
}
.deactivate_containers_pgm .partnerspara_tens > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #1445a4;
}
.deactivate_containers_pgm .partnerspara_tens {
  width: 96%;
  margin: 1rem;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #bcc6d7;
  border-bottom: 1px solid #bcc6d7;
  padding: 1rem 0rem;
}
.deactivate_containers_pgm .Pgm_Profile_businees > img {
  width: 83%;
}
.deactivate_containers_pgm .Pgm_Profile_verification {
  display: flex;
  width: 100%;
}
.deactivate_containers_pgm .Pgm_Profile_verification > img {
  width: 87%;
}
.deactivate_containers_pgm p {
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/PgmDeactivateusers/pgmdetails.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;AACA;EACE,gBAAA;AACF;AAEA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AAAF;AAEA;EACE,YAAA;EACA,mBAAA;AAAF;AAOA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;AALF;AAOE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AALJ;AAOE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AALJ;AAOE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AALJ;AAQE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AANJ;AAQE;EACE,mBAAA;AANJ;AAQE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AANJ;AAQE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AANJ;AAQE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AANJ;AAQE;EACE,WAAA;EACA,YAAA;AANJ;AASE;EACE,aAAA;EACA,cAAA;EACA,mEAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAPJ;AASE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAPJ;AASE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAPJ;AASE;EACE,cAAA;EACA,cAAA;EACF,mBAAA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;AASE;EACE,mBAAA;EACA,mBAAA;EACJ,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAPA;AASE;EACA,mEAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAPF;AASE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAPJ;AASE;EACE,aAAA;EACA,SAAA;AAPJ;AASE;EACE,YAAA;EACD,aAAA;EACA,8BAAA;EACC,mBAAA;EACA,yBAAA;EACA,kBAAA;AAPJ;AAUE;EACE,YAAA;EAEA,mBAAA;EACA,yBAAA;EACA,kBAAA;AATJ;AAWE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;AATJ;AAaA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAXJ;AAaE;EACE,aAAA;EACA,SAAA;AAXJ;AAaE;EACE,oBAAA;AAXJ;AAaE;EACE,aAAA;EACA,YAAA;EACA,SAAA;AAXJ;AAaE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAXJ;AAaE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAXJ;AAaE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAXJ;AAaE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAXJ;AAaE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAXJ;AAaE;EACE,UAAA;EACA,YAAA;AAXJ;AAYI;EACE,YAAA;EACA,WAAA;AAVN;AAaE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAXJ;AAaE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAXJ;AAaE;EACE,UAAA;EACA,8BAAA;AAXJ;AAaE;EACE,gCAAA;AAXJ;AAcE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;AAZJ;AAcE;EACE,YAAA;EACA,aAAA;EACA,SAAA;AAZJ;AAcE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAZJ;AAcE;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAZJ;AAcE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;AAZJ;AAcE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AAZJ;AAcE;EACE,iBAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAZJ;AAcE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;AAZJ;AAcE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;AAZJ;AAcE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAZJ;AAcE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAZJ;AAeE;EACE,aAAA;AAbJ;AAeE;EACE,aAAA;EACA,iBAAA;AAbJ;AAeE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AAbJ;AAeE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AAbJ;AAeE;EACE,oBAAA;AAbJ;AAeE;EACE,qBAAA;AAbJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AAbJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AAbJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;AAbJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;AAbJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;AAbJ;AAeE;EACE,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AAbJ;AAeE;EACE,aAAA;EACA,UAAA;EACA,8BAAA;EACA,YAAA;AAbJ;AAeE;EACE,UAAA;AAbJ;AAeE;EACE,UAAA;AAbJ;AAeE;EACE,aAAA;EACA,WAAA;AAbJ;AAeE;EACE,UAAA;AAbJ;AAeE;EACE,aAAA;EACA,WAAA;AAbJ;AAeE;EACE,UAAA;AAbJ;AAeE;EACE,aAAA;EACA,WAAA;AAbJ;AAgBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAdJ;AAgBE;EACI,YAAA;EACA,aAAA;EACA,oBAAA;AAdN;AAgBE;EACC,YAAA;EACA,aAAA;EACA,qBAAA;AAdH;AAiBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAfJ;AAiBE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;AAfJ;AAiBE;EACE,UAAA;AAfJ;AAiBE;EACE,aAAA;EACA,WAAA;AAfJ;AAiBE;EACE,UAAA;AAfJ;AAiBE;EACE,gBAAA;AAfJ","sourcesContent":[".deactivate_containers_pgm{\n  overflow: hidden;\n  height: 100vh;\n\n.pgmcontainers_details{\n  overflow: hidden;\n}\n\n.pgmdetails_container {\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n  height: 100vh;\n}\n.page_minimize-pgm-details{\n  float: right;\n  margin: 2.4rem 1rem;\n}\n// .page_minimize2 {\n//  position: relative;\n//  right: 2.4rem;\n//  margin: 2.05rem -0.2rem;\n// }\n.vehicle-sale-parts{\n  display: flex;\n  justify-content: space-between;\n  width: 97%;\n  margin: 0rem 1rem;\n}\n  .pgmdetails {\n    width: 100%;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    height: 100vh;\n  }\n  .pgm_details_container_s{\n    overflow-y: scroll;\n    overflow-x: hidden;\n    height: 85vh\n  }\n  .footer-div{\n    margin-top: 1rem;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n  }\n  \n  .header_border {\n    background:#C0C8DA;\n    height: 2.4rem;\n    border: 1px solid #c0c8da;\n  }\n  .header_border > img {\n    margin: 0.9rem 1rem;\n  }\n  .pgmdetails_textbuttons {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem;\n  }\n  .details_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 1.25rem;\n    color: #10132e;\n  }\n  .pgmdetails_firstpara_text_Please {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    color: #ba1a1a;\n    margin: 1rem;\n  }\n  .checkbox {\n    width: 20px;\n    height: 20px;\n  }\n\n  .details_close {\n    width: 4.4rem;\n    height: 1.8rem;\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n  .details_approved {\n    width: 5.7rem;\n    height: 1.8rem;\n    background: #00b55e;\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n  .details_approved:disabled{\n    width: 5.7rem;\n    height: 1.8rem;\n    background: #48f2a0;\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n  .details_need {\n    width: 11.1rem;\n    height: 1.8rem;\n  background: #10132E;\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n  .pgmactive-deactivate{\n    background: #00B55E;\n    font-family: Nunito;\nfont-size: 16px;\nfont-weight: 700;\ncolor: #ffffff;\nmargin: 0rem 0.4rem;\nborder-radius: 5px;\npadding: 0.2rem 0.8rem;\n  }\n  .change-role-deactivate{\n  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\n  font-family: \"Nunito\";\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  padding: 0rem 1rem;\n  margin: 0.8rem 1rem;\n  border-radius: 5px;\n  }\n  .details_need:disabled {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    width: 11.1rem;\n    height: 1.8rem;\n    background: #10132E;\n    border-radius: 5px;\n    border: none;\n    opacity: 0.2;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n  .pgmdetails_allbutoons {\n    display: flex;\n    gap: 1rem;\n  }\n  .pgmdetails_firstpara-deactivate{\n    margin: 1rem;\n   display: flex;\n   justify-content: space-between;\n    background: #f2f4ff;\n    border: 1px solid #c1c6d0;\n    border-radius: 6px;\n  }\n  \n  .pgmdetails_firstpara {\n    margin: 1rem;\n    // height: 3.4rem;\n    background: #f2f4ff;\n    border: 1px solid #c1c6d0;\n    border-radius: 6px;\n  }\n  .pgmdetails_firstpara_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1.12rem;\n    align-items: center;\n    text-align: center;\n    display: flex;\n    gap: 1rem;\n    color: #0c3688;\n    padding: 1rem;\n  }\n  \n\n[role=button] {\n    cursor: pointer;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #0c3688;\n    margin: 1rem 0.5rem;\n}\n  .checkbox_div {\n    display: flex;\n    gap: 1rem;\n  }\n  .pgm-details-pgmlist{\n    word-spacing: 0.4rem;\n  }\n  .checkbox_divs {\n    display: flex;\n    margin: 1rem;\n    gap: 1rem;\n  }\n  .checkbox_divs > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    color: #0c3688;\n  }\n  .googlemaptext {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0c3688;\n    cursor: pointer;\n    display: flex;\n    gap: 0.4rem;\n  }\n  .googlemaptext-bold {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0C3688;\n    cursor: pointer;\n    display: flex;\n    gap: 0.4rem;\n  }\n  .profile_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #0c3688;\n    margin: 0rem 0.9rem;\n  }\n  .profile_pgm_details {\n    background: #f4f6fd;\n    border-radius: 6px;\n    margin: 1rem;\n    display: flex;\n    padding: 1rem 0rem;\n  }\n  .profilepgm_profileicons {\n    width: 20%;\n    margin: 1rem;\n    .profile_img{\n      height: 8rem;\n      width: 8rem;\n    }\n  }\n  .store-img{\n    height: 8.812rem;\n    width: 9.31rem;\n    border: 1px;\n    border-radius: 8px;\n  }\n  .veryfication_images{\n    border-radius: 5px;\n    border: 1px;\n    width: 13.68rem;\n    height: 8.81rem;\n  }\n  .profile_iconstext {\n    width: 80%;\n    border-left: 2px solid #ffffff;\n  }\n  .Profile_icon_border {\n    border-bottom: 2px solid #ffffff;\n  }\n\n  .Profile_icon_text_spare {\n    display: flex;\n    justify-content: space-between;\n    width: 60.5%;\n    margin: 1rem;\n  }\n  .Profile_icon_text_span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex;\n    color: #0c3688;\n    gap: 1rem;\n  }\n  .Profile_icon_text_para {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #32363f;\n    gap: 1rem;\n    display: flex;\n  }\n  .Profilepgmdetails_email {\n    margin: 1rem;\n    display: flex;\n    gap: 1rem;\n  }\n  .pgm_details_parathird {\n    background: #f2f4ff;\n    border-radius: 6px;\n    margin: 1rem;\n    display: flex;\n    justify-content: space-between;\n  }\n  .pgm_details_parathird > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    display: flex;\n    color: #0c3688;\n    padding: 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n  .pgm_details_parathird > img {\n    width: 31px;\n    height: 31px;\n    padding: 1rem;\n  }\n  .pgm_details_parafourth {\n    background: #f2f4ff;\n    border-radius: 6px;\n    margin: 1rem;\n  }\n  .pgm_details_parafourth_textspare {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem;\n  }\n  .pgm_details_parafourth_textspare > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #0c3688;\n    margin: 0.7rem 0rem;\n    display: flex;\n    gap: 1rem;\n    padding: 0.4rem;\n  }\n  .pgm_details_parafourth_textsparespans {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #0c3688;\n    margin: 1rem 0rem;\n    display: flex;\n    gap: 1rem;\n    padding: 0.4rem;\n  }\n  .pgm_details_parafourth_textspare > img {\n    margin: 1rem 0rem;\n  }\n  .pgm_details_parafive {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #0c3688;\n    margin: 1rem;\n  }\n  .pgmdetails_parasix {\n    height: 49px;\n    background: #f2f4ff;\n    border-radius: 6px;\n    margin: 1rem 0rem;\n    width: 99%;\n  }\n  .pgmdetails_sixspan {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    color: #32363f;\n    padding: 1rem;\n    display: flex;\n  }\n  .veryfication_border {\n    background: #ffffff;\n    border: 1px solid #a3aec4;\n    border-radius: 5px;\n  }\n  .veryfication_img {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin: 1rem;\n  }\n\n  .pgm_details_sevenpara {\n    display: flex;\n  }\n  .pgm_details_sevenparas {\n    display: flex;\n    margin: 1rem 0rem;\n  }\n  .pgm_details_eight_paras {\n    display: flex;\n    gap: 1.5rem;\n    margin: 2rem 0rem;\n  }\n  .veryfication_img > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    color: #0c3688;\n    display: flex;\n    gap: 1rem;\n  }\n  .veryfication_img >img{\n    margin: -0.6rem 0rem;\n  }\n  .commercial {\n    margin-top: 8rem 0rem;\n  }\n  .Profile_icon_text_organization {\n    display: flex;\n    justify-content: space-between;\n    width: 72%;\n    margin: 1rem;\n  }\n  .Profile_icon_text_organization_records {\n    display: flex;\n    justify-content: space-between;\n    width: 72%;\n    margin: 1rem;\n  }\n  .Profile_icon_text_records_businees {\n    display: flex;\n    justify-content: space-between;\n    width: 80.5%;\n    margin: 1rem;\n  }\n  .Profile_icon_text_postal {\n    display: flex;\n    justify-content: space-between;\n    width: 65.5%;\n    margin: 1rem;\n  }\n  .Profile_icon_text_province {\n    display: flex;\n    justify-content: space-between;\n    width: 70.5%;\n    margin: 1rem;\n  }\n  .Profile_icon_text {\n    display: flex;\n    width: 96%;\n    margin: 1rem 1.4rem;\n    padding: 0rem 0rem;\n  }\n  .Profile_icon_text_profiledetails {\n    display: flex;\n    width: 70%;\n    justify-content: space-between;\n    margin: 1rem;\n  }\n  .profile_commercial {\n    width: 46%;\n  }\n  .profile_commercials {\n    width: 46%;\n  }\n  .Pgm_Profile_details {\n    display: flex;\n    width: 100%;\n  }\n  .Pgm_Profile_details > img {\n    width: 85%;\n  }\n  .Pgm_Profile_questionaire {\n    display: flex;\n    width: 100%;\n  }\n  .Pgm_Profile_questionaire > img {\n    width: 78%;\n  }\n  .Pgm_Profile_businees {\n    display: flex;\n    width: 100%;\n  }\n  \n  .partnerspara_tens_span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #1445a4;\n    padding: 1rem 0rem;\n    margin:1rem ;\n  }\n  .page_minimizes{\n      float: right;\n      right: 2.4rem;\n      margin: 0rem -0.1rem;\n  }\n  .page_minimize2s {\n   float: right;\n   right: 2.4rem;\n   margin: 1.6rem 0.8rem;\n   \n  }\n  .partnerspara_tens >  span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #1445a4;\n  }\n  .partnerspara_tens {\n    width: 96%;\n    margin: 1rem;\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #bcc6d7;\n    border-bottom: 1px solid #bcc6d7;\n    padding: 1rem 0rem;\n  }\n  .Pgm_Profile_businees > img {\n    width: 83%;\n  }\n  .Pgm_Profile_verification {\n    display: flex;\n    width: 100%;\n  }\n  .Pgm_Profile_verification > img {\n    width: 87%;\n  }\n  p {\n    background: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
